import createIcon from '../../createIcon';

/**
 * @component @name HowToReg
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguNSAxNi43NUwxMS41IDEzLjgxQzExLjExIDEzLjc3IDEwLjgyIDEzLjc1IDEwLjUgMTMuNzVDNy44MyAxMy43NSAyLjUgMTUuMDkgMi41IDE3Ljc1VjE5Ljc1SDExLjVMOC41IDE2Ljc1Wk0xMC41IDExLjc1QzEyLjcxIDExLjc1IDE0LjUgOS45NiAxNC41IDcuNzVDMTQuNSA1LjU0IDEyLjcxIDMuNzUgMTAuNSAzLjc1QzguMjkgMy43NSA2LjUgNS41NCA2LjUgNy43NUM2LjUgOS45NiA4LjI5IDExLjc1IDEwLjUgMTEuNzVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0Ljk3IDIwLjI1TDExLjUgMTYuNzVMMTIuOSAxNS4zNEwxNC45NyAxNy40MkwyMC4xIDEyLjI1TDIxLjUgMTMuNjZMMTQuOTcgMjAuMjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HowToReg = createIcon('HowToReg', [
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.5 16.75L11.5 13.81C11.11 13.77 10.82 13.75 10.5 13.75C7.83 13.75 2.5 15.09 2.5 17.75V19.75H11.5L8.5 16.75ZM10.5 11.75C12.71 11.75 14.5 9.96 14.5 7.75C14.5 5.54 12.71 3.75 10.5 3.75C8.29 3.75 6.5 5.54 6.5 7.75C6.5 9.96 8.29 11.75 10.5 11.75Z',
      key: 'sve8m4',
    },
  ],
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.97 20.25L11.5 16.75L12.9 15.34L14.97 17.42L20.1 12.25L21.5 13.66L14.97 20.25Z',
      key: 'gdayvf',
    },
  ],
]);

export default HowToReg;
